
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.989 12a4.768 4.768 0 01-3.8-7.654c.265-.373.586-.701.952-.974a.429.429 0 01.493 0 .429.429 0 01.155.48 3.405 3.405 0 000 1.716 1.046 1.046 0 001.046.737.665.665 0 00.51-.227.965.965 0 000-.81C3.06.864 4.658.122 4.847.028a.429.429 0 01.579.428c-.069.742-.124 1.33 1.136 2.114l.073.039c2.599 1.364 3.148 3.263 3.148 4.614A4.781 4.781 0 014.989 12zm-3.17-7.063a3.91 3.91 0 107.085 2.29c0-1.115-.468-2.688-2.689-3.86-.06-.033-.107-.055-.129-.072A3.323 3.323 0 014.701 1.88a8.31 8.31 0 00.43 3.126 1.715 1.715 0 01-.104 1.552 1.47 1.47 0 01-1.17.6 1.904 1.904 0 01-1.913-1.324 3.147 3.147 0 01-.124-.897z","fill":"#000C1F","fill-opacity":".8"}})])
          )
        }
      }
    